import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import Loading from 'src/components/Loading'
import { useOffer } from 'src/hooks/offer'
import { getSection } from 'src/hooks/useContentful/getSection'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import contentfulClient from '../../../../services/contentful'
import * as S from './styles'
import { useMemo } from 'react'
import Footer from './Footer'
import CardPartner from './CardPartner'
import { addHours, isWithinInterval } from 'date-fns'

function Planos() {
	const [loading, setLoading] = useState(false)
	const { setCurrentOffer } = useOffer()
	const content = useFetchContent()
	const promotionalCode = useMemo(
		() => content.data.fields.promotionalCodes.split('@')[0],
		[content.data.fields.promotionalCodes]
	)
	const hasCoupon = useMemo(() => content.data.fields.hasCoupon, [
		content.data.fields.hasCoupon
	])

	useEffect(() => {
		if (hasCoupon) setCurrentOffer(promotionalCode)
	}, [hasCoupon, promotionalCode, setCurrentOffer])

	const section = getSection({
		sectionName: 'landingDefaultPromo',
		data: content.data
	})

	const typePlans = ['pedagiosEstacionamentos', 'estacionamentos', 'pedagios']
	const plans = useQuery(
		'getCardPlan',
		() =>
			Promise.all(
				typePlans
					.filter(field => Object.keys(section).includes(field))
					.map(
						async field =>
							await contentfulClient.getEntry(section[field].sys.id)
					)
			),
		{
			enabled: content.data && !content.isLoading,
			retry: false
		}
	)

	useEffect(() => {
		setLoading(plans.isLoading || content.isLoading)
	}, [plans.isLoading, content.isLoading])

	if (loading || !plans.data) return <Loading />

	const bonusText = () => {
		const bonusStart = addHours(new Date('2024-10-15'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

    const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(isBetween) return "*Condição válida até 14/12/24."

		return null
  }

	const adesaoText = () => {
		const bonusStart = addHours(new Date('2024-10-15'), 3)
		const bonusEnd = addHours(new Date('2024-12-14'), 3)
		const today = addHours(new Date(), 3)

    const isBetween = isWithinInterval(today, { start: bonusStart, end: bonusEnd });

		if(isBetween) return "+ Adesão grátis*"

		return null
  }

	const fixedPlans = {
		data: [
			{
				fields: {
					benefits: {
							title: {
								description: 'Clientes Bradesco possuem mensalidade',
								firstPrice: {
									text: 'de',
									price: 'R$ 18,90'
								},
								secondPrice: 'Por R$ 5 ou GRÁTIS!',
								adesao: adesaoText() || '+ Adesão R$ 20',
								promo: bonusText(),
								footer: 'Pague com o cartão de crédito Bradesco para garantir condições especiais',
								observation: '¹Pague com o cartão de crédito Bradesco para garantir condições especiais'
							},
							partners: [
								{
									title: 'Exclusive',
									subtitle: 'Clientes com mensalidade grátis na 1ª Tag(2)!',
									description: '(2) Válido para titular de c/c e do cartão de crédito Bradesco com gasto a partir de R$ 2 mil, considerando o valor médio das 3 últimas faturas.'
								},
								{
									title: 'Prime',
									subtitle: 'Clientes com mensalidade grátis na 1ª Tag(2) e na 2ª tag (3)!',
									description: '(2) Válido para titular de c/c e do cartão de crédito Bradesco com gasto a partir de R$ 2 mil, considerando o valor médio das 3 últimas faturas. (3) Clientes com gasto superior a R$ 5 mil no cartão de crédito tem gratuidade também na mensalidade da 2ª tag.'
								},
							]
					}
				}
			}
		]
	}

	//const newPlans = plans.data[0].fields.benefits.title ? plans : fixedPlans
	const newPlans = fixedPlans

	return (
		<S.Container id="plans">
			<S.TopContent>
				<S.Info>
					<S.Title>{newPlans.data[0].fields.benefits.title.description}</S.Title>
					<S.Price>
						<span>{newPlans.data[0].fields.benefits.title.firstPrice.text} <s>{newPlans.data[0].fields.benefits.title.firstPrice.price}</s></span>
					</S.Price>
					<S.SecondPrice>{newPlans.data[0].fields.benefits.title.secondPrice}</S.SecondPrice>
					<S.Adesao>{newPlans.data[0].fields.benefits.title.adesao}</S.Adesao>
					{bonusText() && (
						<S.Promo>{newPlans.data[0].fields.benefits.title.promo}</S.Promo>
					)}
					<S.Observation>{newPlans.data[0].fields.benefits.title.observation}</S.Observation>
				</S.Info>
				<S.MainImage>
					<img src='/bradescoclassic/assets/bra_classic_plan_img.svg' alt='Imagem Tag Bradesco e Veloe'/>
				</S.MainImage>
			</S.TopContent>
			<S.Partners>
				<>
					{newPlans.data[0].fields.benefits.partners.map((p, index) => <CardPartner data={p} key={index} />)}
					<Footer
						buttonColor={plans.data[0].fields.corDoBotao}
						terms={section.regulamento}
						textColor={'#FFFFFF'}
						cupons={[
							plans.data[0].fields.firstButtonCoupon
						]}
						validade={plans.data[0].fields.validate}
					/>
				</>
			</S.Partners>
		</S.Container>
	)
}
export default Planos
